import React from 'react';
import './index.scss';
import LogoS from '../../../assets/images/rb.jpg';

const Logo = () => {
  return (
    <div className="logo-container">
      <img
        className="solid-logo"
        src={LogoS}
        alt="JavaScript Developer"
      />
    </div>
  );
};

export default Logo;
